<div class="match-container">
  <div class="match-header">
    <div class="header-content">
      <div class="match-title-section">
        <h1 class="match-title">
          @if (yourMatchComponent) { Your Match } @else { Confirm Match }
        </h1>
        <div class="match-status">
          @if (courtReservation.finished) {
          <div class="status-badge finished">
            <lucide-icon name="circle-check" [size]="14"></lucide-icon>
            Completed
          </div>
          } @else if (courtReservation.started) {
          <div class="status-badge active">
            <lucide-icon name="circle-dot" [size]="14"></lucide-icon> In
            Progress
          </div>
          } @else {
          <div class="status-badge pending">
            <lucide-icon name="clock" [size]="14"></lucide-icon> Scheduled
          </div>
          }
        </div>
      </div>
    </div>
  </div>

  <div class="match-content">
    <div class="players-section">
      <div class="section-header">
        <h2 class="section-title">Players</h2>
        <div class="match-type-badge">
          @if(selectedMatchType == 'double') {
          <span class="type-icon"
            ><lucide-icon name="users" [size]="16"></lucide-icon
          ></span>
          <span>Doubles</span>
          } @else {
          <span class="type-icon"
            ><lucide-icon name="user" [size]="16"></lucide-icon
          ></span>
          <span>Singles</span>
          }
        </div>
      </div>

      <div class="teams-container">
        @if(selectedMatchType == 'double') {
        <div class="team-section">
          <div class="team-header">
            <h3 class="team-title">Team 1</h3>
          </div>
          <div class="players-grid">
            <div class="player-card" (click)="choosePlayer(0)">
              <div class="player-number">1</div>
              <div class="player-name">{{ playerName(0) }}</div>
            </div>
            <div class="player-card" (click)="choosePlayer(2)">
              <div class="player-number">2</div>
              <div class="player-name">{{ playerName(2) }}</div>
            </div>
          </div>
        </div>

        <div class="vs-divider">
          <div class="vs-circle">VS</div>
        </div>

        <div class="team-section">
          <div class="team-header">
            <h3 class="team-title">Team 2</h3>
          </div>
          <div class="players-grid">
            <div class="player-card" (click)="choosePlayer(1)">
              <div class="player-number">1</div>
              <div class="player-name">{{ playerName(1) }}</div>
            </div>
            <div class="player-card" (click)="choosePlayer(3)">
              <div class="player-number">2</div>
              <div class="player-name">{{ playerName(3) }}</div>
            </div>
          </div>
        </div>
        } @else {
        <div class="singles-container">
          <div class="player-card large" (click)="choosePlayer(0)">
            <div class="player-avatar">
              <lucide-icon name="user" [size]="24"></lucide-icon>
            </div>
            <div class="player-name">{{ playerName(0) }}</div>
            <div class="player-label">You</div>
          </div>

          <div class="vs-divider">
            <div class="vs-circle">VS</div>
          </div>

          <div class="player-card large" (click)="choosePlayer(1)">
            <div class="player-avatar">
              <lucide-icon name="user" [size]="24"></lucide-icon>
            </div>
            <div class="player-name">{{ playerName(1) }}</div>
            <div class="player-label">Opponent</div>
          </div>
        </div>
        }
      </div>
    </div>

    @if (!yourMatchComponent || !courtReservation.started) {
    <div class="match-info-section">
      <div class="section-header">
        <h2 class="section-title">Match Details</h2>
      </div>

      <div class="info-grid">
        <div class="info-card">
          <div class="info-icon">
            <lucide-icon name="calendar" [size]="18"></lucide-icon>
          </div>
          <div class="info-content">
            <div class="info-label">Date</div>
            <div class="info-value">{{ getDate() }}</div>
          </div>
        </div>

        <div class="info-card">
          <div class="info-icon">
            <lucide-icon name="clock" [size]="18"></lucide-icon>
          </div>
          <div class="info-content">
            <div class="info-label">Time</div>
            <div class="info-value">{{ getTime() }}</div>
          </div>
        </div>

        <div class="info-card">
          <div class="info-icon">
            <lucide-icon name="landmark" [size]="18"></lucide-icon>
          </div>
          <div class="info-content">
            <div class="info-label">Court</div>
            <div class="info-value">Court {{ getCourtNumber() }}</div>
          </div>
        </div>

        <div class="info-card">
          <div class="info-icon">
            <lucide-icon name="home" [size]="18"></lucide-icon>
          </div>
          <div class="info-content">
            <div class="info-value">{{ getClub() }}</div>
          </div>
        </div>
      </div>
    </div>
    }

    <div class="score-section">
      <div class="section-header">
        <h2 class="section-title">Match Score</h2>
        @if (yourMatchComponent && courtReservation.started &&
        !courtReservation.finished) {
        <div
          class="score-status"
          [class.complete]="isMatchReadyToComplete()"
          [class.incomplete]="!isMatchReadyToComplete()"
        >
          @if (isMatchReadyToComplete()) {
          <div class="status-icon">
            <lucide-icon name="circle-check" [size]="16"></lucide-icon>
          </div>
          <span class="status-text">Ready to Complete</span>
          } @else {
          <div class="status-icon">
            <lucide-icon name="edit" [size]="16"></lucide-icon>
          </div>
          <span class="status-text">Enter all scores</span>
          }
        </div>
        }
      </div>

      <div class="score-table">
        <div class="score-header">
          <div class="team-label">Team</div>
          <div class="set-label">Set 1</div>
          <div class="set-label">Set 2</div>
          <div class="set-label">Set 3</div>
        </div>

        <div class="score-row">
          <div class="team-name">Team 1</div>
          <div class="score-input-wrapper">
            <input
              class="score-input"
              type="text"
              [(ngModel)]="points[0]"
              (blur)="onInputDone(0)"
              (click)="onInputClick(0)"
              [disabled]="courtReservation.finished"
              placeholder="0"
            />
          </div>
          <div class="score-input-wrapper">
            <input
              class="score-input"
              type="text"
              [(ngModel)]="points[1]"
              (blur)="onInputDone(1)"
              (click)="onInputClick(1)"
              [disabled]="courtReservation.finished"
              placeholder="0"
            />
          </div>
          <div class="score-input-wrapper">
            <input
              class="score-input"
              type="text"
              [(ngModel)]="points[2]"
              (blur)="onInputDone(2)"
              (click)="onInputClick(2)"
              [disabled]="courtReservation.finished"
              placeholder="0"
            />
          </div>
        </div>

        <div class="score-row">
          <div class="team-name">Team 2</div>
          <div class="score-input-wrapper">
            <input
              class="score-input"
              type="text"
              [(ngModel)]="points[3]"
              (blur)="onInputDone(3)"
              (click)="onInputClick(3)"
              [disabled]="courtReservation.finished"
              placeholder="0"
            />
          </div>
          <div class="score-input-wrapper">
            <input
              class="score-input"
              type="text"
              [(ngModel)]="points[4]"
              (blur)="onInputDone(4)"
              (click)="onInputClick(4)"
              [disabled]="courtReservation.finished"
              placeholder="0"
            />
          </div>
          <div class="score-input-wrapper">
            <input
              class="score-input"
              type="text"
              [(ngModel)]="points[5]"
              (blur)="onInputDone(5)"
              (click)="onInputClick(5)"
              [disabled]="courtReservation.finished"
              placeholder="0"
            />
          </div>
        </div>
      </div>
    </div>

    @if (courtReservation.finished && yourMatchComponent) {
    <div class="points-section">
      <div class="section-header">
        <h2 class="section-title">Points Calculation</h2>
      </div>

      <div class="points-container">
        @for (playerPoints of getPlayerPointsCalculation(); track
        playerPoints.playerId) {
        <div class="player-points-card" [class.winner]="playerPoints.isWinner">
          <div class="player-info">
            <div class="player-name">{{ playerPoints.playerName }}</div>
            <div class="player-result">
              {{ playerPoints.isWinner ? "Winner" : "Runner-up" }}
            </div>
          </div>
          <div class="points-breakdown">
            <div class="points-item">
              <span class="points-label">Base Points:</span>
              <span class="points-value">+15</span>
            </div>
            <div class="points-item">
              <span class="points-label"
                >Sets Won ({{ playerPoints.setsWon }}):</span
              >
              <span class="points-value">+{{ playerPoints.setsWon * 20 }}</span>
            </div>
            <div class="points-item">
              <span class="points-label"
                >Sets Lost ({{ playerPoints.setsLost }}):</span
              >
              <span class="points-value">-{{ playerPoints.setsLost * 5 }}</span>
            </div>
            @if (playerPoints.isWinner) {
            <div class="points-item winner-bonus">
              <span class="points-label">Winner Bonus:</span>
              <span class="points-value">+20</span>
            </div>
            }
            <div class="points-total">
              <span class="points-label">Total RB Points:</span>
              <span class="points-value total"
                >{{ playerPoints.totalPoints >= 0 ? "+" : ""
                }}{{ playerPoints.totalPoints }}</span
              >
            </div>
          </div>
        </div>
        }
      </div>
    </div>
    }

    <div class="action-section">
      <button
        class="primary-action-button"
        [disabled]="
          courtReservation.finished ||
          courtReservation.end_match_request_pending ||
          (yourMatchComponent &&
            courtReservation.started &&
            !isMatchReadyToComplete())
        "
        [class.disabled]="
          courtReservation.finished ||
          courtReservation.end_match_request_pending ||
          (yourMatchComponent &&
            courtReservation.started &&
            !isMatchReadyToComplete())
        "
        [class.incomplete]="
          yourMatchComponent &&
          courtReservation.started &&
          !isMatchReadyToComplete()
        "
        (click)="
          !yourMatchComponent
            ? confirmMatch()
            : courtReservation.started
            ? saveAndEndMatch()
            : startMatch()
        "
      >
        <div class="button-content">
          @if (!yourMatchComponent) {
          <div class="button-icon">
            <lucide-icon name="check" [size]="18"></lucide-icon>
          </div>
          <span>Confirm Match</span>
          } @else if (courtReservation.started) { @if
          (courtReservation.finished) {
          <div class="button-icon">
            <lucide-icon name="trophy" [size]="18"></lucide-icon>
          </div>
          <span>Match Completed</span>
          } @else if (courtReservation.end_match_request_pending) {
          <div class="button-icon">
            <lucide-icon name="loader-2" [size]="18"></lucide-icon>
          </div>
          <span>Pending Approval</span>
          } @else { @if (isMatchReadyToComplete()) {
          <div class="button-icon">
            <lucide-icon name="check" [size]="18"></lucide-icon>
          </div>
          <span>Complete Match</span>
          } @else {
          <div class="button-icon">
            <lucide-icon name="edit" [size]="18"></lucide-icon>
          </div>
          <span>Enter All Scores to Complete</span>
          } } } @else {
          <div class="button-icon">
            <lucide-icon name="circle-dot" [size]="18"></lucide-icon>
          </div>
          <span>Start Match</span>
          }
        </div>
      </button>
    </div>
  </div>
</div>
